export default {
  clientProfile: '/client-profile',
};
